// Imported blog HTML carries leftover inline typography from the original CMS
// (font-family: Poppins, font-size: 22px !important, font-weight: 300, ...).
// Those inline declarations beat our stylesheet, so posts render at different
// sizes and faces. Strip them so every article uses the shared blog typography.

const TYPOGRAPHY_PROPS =
  /(?:^|;)\s*(?:font|font-family|font-size|font-weight|font-style|line-height|letter-spacing)\s*:[^;]*/gi;

export function normalizeBlogTypography(html: string | null | undefined): string {
  if (!html) return "";

  let out = html.replace(
    /style\s*=\s*"([^"]*)"/gi,
    (_match, css: string) => {
      const cleaned = css
        .replace(TYPOGRAPHY_PROPS, "")
        .replace(/^\s*;+/, "")
        .replace(/;\s*;+/g, ";")
        .trim();
      return cleaned ? `style="${cleaned}"` : "";
    },
  );

  // Legacy <font size="..."> / <font face="..."> wrappers.
  out = out.replace(/<font\b[^>]*>/gi, "<span>").replace(/<\/font\s*>/gi, "</span>");

  return out;
}
